import React from 'react';
import './content.scss';
import { parseImage } from '@/utils/media-transfer';
import dsi18n from '@/i18n/ds';
import { DotElement, dotSceneNameMap } from '@/components/dots';
import Share from '../share';
import List from '@/components/blog-list';
import {
  SEARCH_PRODUCT,
  START_DROP_SHIPPING,
  LEARN_DROP_SHIPPING,
  SCALE_YOURS_SCALE,
  FIND_IDEAL,
} from '@/utils/page-links';
import { articleDetailType } from '../typing';

function Content(props: { article: articleDetailType; channelName: string }) {
  const { article, channelName } = props;
  // 拿到传过来的类型

  // context转义
  function unescape(str: any): any {
    let elem = document.createElement('div');
    elem.innerHTML = str;
    return elem.innerText || elem.textContent;
  }
  let text: any = unescape(article.context);
  const clickScene = dotSceneNameMap.blogDetail.popularList;
  const goBack = (): string => {
    switch (channelName) {
      case 'Scale_Your_Sales':
        return SCALE_YOURS_SCALE;
      case 'Learn_DS':
        return LEARN_DROP_SHIPPING;
      case 'Find_Ideas':
        return FIND_IDEAL;
      default:
        return START_DROP_SHIPPING;
    }
  };

  return (
    <div>
      {/* 置顶区域 左侧置顶 右侧 list请求列表 */}
      <div className="banner-width blog-content">
        <div className="blog-section-left">
          <DotElement
            dotType="clk"
            dotParams={{
              scene: dotSceneNameMap.blogDetail.detail,
              action: 'go_back',
              channelName: window.__channelName,
            }}
            style={{ marginBottom: '16px', cursor: 'pointer', color: '#007ffc', fontSize: '16px' }}
            className="goback"
            url={goBack()}
            target="_self">
            {dsi18n('article.navi.GoBackToList')}
          </DotElement>
          {/* detail-title */}
          <div className="blog-detail">
            <div className="detail-title">{article.name}</div>
            <div className="detail-time">{article.publishDate}</div>
            <ul className="detail-section">
              <li
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
              />
            </ul>
          </div>
          <Share article={article} />
        </div>

        <div className="blog-section-right">
          {/* <div className="list-title">{dsi18n('LatestArticlesList')}</div> */}
          <List clickScene={clickScene} />
          <DotElement
            dotType="clk"
            dotParams={{
              scene: dotSceneNameMap.blogDetail.popularList,
              action: `blog_Detail_banner_click`,
              channelName: window.__channelName,
            }}
            className="list-banner banner-height"
            url={`${SEARCH_PRODUCT}`}>
            <img
              src={parseImage({
                img: 'https://img.alicdn.com/imgextra/i2/O1CN01Nj1sQW1iTCXiGr2nb_!!6000000004413-0-tps-652-214.jpg',
              })}
              alt=""
              className="bannerImg"
            />
            <div className="banner-text">
              <span>{dsi18n('sidebanner.FindNiches')}</span>
              <br />
              <span>{dsi18n('sidebanner.FindNiches.Subline')}</span>
            </div>
          </DotElement>
        </div>
      </div>
    </div>
  );
}

export default Content;
